import React, { Component } from 'react';
import DeviceData from 'drivers/deviceData';
import EventBus from 'utils/eventBus';
import getLocalizedNews from 'components/news/getLanguageData';
import getIsRTLLanguage from 'utils/common/isRTL';
import { measureComponent } from 'utils/common/measureComponent';
import { ContentStepItem } from 'components/main/warwick/styles';
import { isValidUrl } from 'utils/validations/url_validation';
import StorageKeys from 'enum/storages.enum';
import Storages from 'storages';
import { Landing } from 'enum/design';

class NewsContainer extends Component {
  constructor(props) {
    super(props);
    this.subscriptions = {};
    this.state = {
      focusIndex: 0,
      items: [],
      redirectBack: false,
      showError: false,
      loading: true,
      allowedItems: 1,
      displayedItems: [],
    };
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  _renderMenuItem() {
    return <ContentStepItem key='test-1'>Test Step</ContentStepItem>;
  }

  async componentDidMount() {
    this.subscriptions = EventBus.subscribe('refresh', this.getData.bind(this));
    this.getData();
    window.addEventListener('keydown', this.onKeyPress);

    const totalItems = await measureComponent(() => this._renderMenuItem());
    if (this.state.allowedItems !== totalItems) {
      this.setState({ allowedItems: totalItems });
    }
  }

  componentWillUnmount() {
    this.subscriptions?.unsubscribe();
    window.removeEventListener('keydown', this.onKeyPress);
  }

  async getData() {
    let language = getLocalizedNews();
    let data = language.languageData;
    let news = [];
    let counter = 0;
    data !== null &&
      data.forEach((newsItem, index_1) => {
        newsItem.active = counter === 0;
        counter++;
        news.push(newsItem);
      });
    const isWarwick = Storages.MainStorage.getItem(StorageKeys.Keys.ACTIVETEMPLATE) === Landing.Warwick;
    this.setState({
      showError: language.setstate.showError,
      loading: language.setstate.loading,
      items: news.filter((newsItem) => {
        return isWarwick ? isValidUrl(newsItem.locale_latest_news?.locale_description) : true;
      }),
    });
  }

  toggleItem(currentItem) {
    let indexToFocus = 0;
    this.setState(
      (state) => {
        return {
          items: state.items.map((item, idx) => {
            item.active = currentItem.id === item.locale_latest_news.id;
            if (item.active) {
              indexToFocus = idx;
            }
            return item;
          }),
        };
      },
      () => {
        this.setState({
          focusIndex: indexToFocus,
        });
      }
    );
  }

  clickHandler(event, currentItem) {
    this.toggleItem(currentItem);
  }

  async onKeyPress(event) {
    const tvKeyControls = await DeviceData.getTVControl();

    let newIndex;
    const isRTL = getIsRTLLanguage();
    const KEY_LEFT_DIRECTION = isRTL ? tvKeyControls.KEY_RIGHT : tvKeyControls.KEY_LEFT;
    const KEY_RIGHT_DIRECTION = isRTL ? tvKeyControls.KEY_LEFT : tvKeyControls.KEY_RIGHT;

    switch (event.keyCode) {
      case KEY_RIGHT_DIRECTION:
        newIndex = this.state.focusIndex + 1;
        break;
      case KEY_LEFT_DIRECTION:
        newIndex = this.state.focusIndex - 1;
        break;
      case tvKeyControls.KEY_BACK:
        this.setState({
          redirectBack: true,
        });
        event.preventDefault();
        break;

      default:
        break;
    }
    if (this.state.items.length === newIndex) newIndex = 0;

    if (newIndex < 0) newIndex = this.state.items.length - 1;

    if (newIndex >= 0 && newIndex < this.state.items.length) {
      this.toggleItem(this.state.items[newIndex]?.locale_latest_news);
    }
  }

  render() {
    throw new Error('NewsContainer is an abstract class and cannot be rendered directly');
    return <></>;
  }
}

export default NewsContainer;
